export enum ApiPermissions {
    READ_SERVICES = 'read-services',
    CREATE_SERVICES = 'create-services',
    UPDATE_SERVICES = 'update-services',

    CREATE_PLANS = 'create-plans',
    UPDATE_PLANS = 'update-plans',
    DELETE_PLANS = 'delete-plans',

    CREATE_VEHICLES = 'create-vehicles',
    UPDATE_VEHICLES = 'update-vehicles',
    DELETE_VEHICLES = 'delete-vehicles',

    CREATE_SUBSCRIPTIONS = 'create-subscriptions',
    UPDATE_SUBSCRIPTIONS = 'update-subscriptions',
    SUSPEND_SUBSCRIPTIONS = 'suspend-subscriptions',
    CANCEL_SUBSCRIPTIONS = 'cancel-subscriptions',
}
